import { render, staticRenderFns } from "./DataTableSearchbox.vue?vue&type=template&id=6fcdb13d&lang=pug&"
import script from "./DataTableSearchbox.vue?vue&type=script&lang=js&"
export * from "./DataTableSearchbox.vue?vue&type=script&lang=js&"
import style0 from "./DataTableSearchbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DataTableSearchbox.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VTextField,
})
